import React from 'react';
import { connect } from 'react-redux';
import { getFaultyMachines } from 'redux/selectors';
import { Identification, SectionData } from '@umati/dashboard-common';
import { Card } from 'react-bootstrap';

const FaultyMachineList = (props) => {
  const colStyle = 'col-12 col-sm-12 col-md-12';
  return (
    <div className="container view-list">
      <ul className="list-group">
        <li className="list-group-item">
          {
            props.faultyMachines.map(fm => {
              return <><Card key={fm.MachineId}>
                <div className="card-body">
                <Identification {...fm.Data}></Identification>
                </div>
                  <div className="card-body">
                    <div className="section">
                      <SectionData cols={colStyle} label="Error" value={fm.Error} />
                    </div>
                </div>
              </Card>
              </>;
            })
          }
        </li>
      </ul>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    faultyMachines: getFaultyMachines(state)
  };
};

export default connect(mapStateToProps)(FaultyMachineList);
